import servicesUtils from "../../../utils/servicesUtils";
var addEditReminder = function addEditReminder(data, patientUid, reminderId) {
  if (!!reminderId) {
    return servicesUtils.postService("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/"), data);
  }
  return servicesUtils.postService("/patients/".concat(patientUid, "/reminder/create/"), data);
};
export default addEditReminder;